export default __webpack_public_path__ + "static/media/logo.9a3ec995.jpg";